module.exports = __webpack_public_path__ + "static/media/agua.c6f240c5.jpg";